<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="emEquipmentcheckrecords"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <!--        <el-button type="primary" @click="$refs.editEMEquipmentcheckrecord.open(0)">新建</el-button>-->
        <el-button type="primary" @click="$refs.addByDate.open(0)">根据日期生成日点检项目</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="设备编号">
            <el-input v-model.trim="filter.equipmentNO" clearable/>
          </vm-search>
          <vm-search label="检查结果">
            <el-select v-model.trim="filter.checkResult" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.checkResults)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="点检时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.checkMonthStart"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 150px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至" class="zhi">
            <div class="block">
              <el-date-picker
                  v-model="filter.checkMonthEnd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 150px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="equipmentNO" align="center" label="设备编号" width="120"/>
      <el-table-column prop="checkMonth" align="center" label="点检月份" width="120"/>
      <el-table-column prop="checkContent" align="center" label="检查内容"/>
      <el-table-column prop="checkWay" align="center" label="检查方法"/>
      <el-table-column prop="checkType" align="center" label="检查类型" width="100">
        <template slot-scope="scope">
          <span>{{constant.checkTypes[scope.row.checkType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="checkUserName" align="center" label="检查人" width="100"/>
      <el-table-column prop="checkResult" align="center" label="检查结果" width="160">
        <template slot-scope="scope">
          <span>{{constant.checkResults[scope.row.checkResult]}}</span>
        </template>
      </el-table-column>
      <!--      <el-table-column-->
      <!--          label="操作"-->
      <!--          align="center"-->
      <!--          class-name="vm-table_operate"-->
      <!--          width="150px">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button type="info" @click="$refs.editEMEquipmentcheckrecord.open(scope.row.pkid)">编辑</el-button>-->
      <!--          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </vm-table>
    <add-by-date-edit ref="addByDate" @save-success="getList(1)"/>
    <e-m-equipmentcheckrecord-edit ref="editEMEquipmentcheckrecord" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import addByDateEdit from "@/views/em/EMEquipmentcheckrecord/addByDateEdit";
  import EMEquipmentcheckrecordEdit from "@/views/em/EMEquipmentcheckrecord/EMEquipmentcheckrecordEdit";

  export default {
    name: "EMEquipmentcheckList",
    components: {EMEquipmentcheckrecordEdit,addByDateEdit, VmTable,VmSearch},
    data() {
      return {
        constant,
        idList: "",
        exportLoading: false,
        importLoading: false,
        disabled: false,
        filter: {
          equipmentNO: "",
          checkResult: "",
          checkMonthStart: "",
          checkMonthEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","emEquipmentcheckrecords",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
